/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ScholarshipfileapprovalFiles202,
  PostApiV1ScholarshipfileapprovalFiles400,
  PostApiV1ScholarshipfileapprovalFiles401,
  PostApiV1ScholarshipfileapprovalFiles404,
  PostApiV1ScholarshipfileapprovalFiles500,
  PostApiV1ScholarshipfileapprovalFilesMutationRequest,
  PostApiV1ScholarshipfileapprovalFilesMutationResponse,
} from "../../types/scholarshipTypeFileApprovalController/PostApiV1ScholarshipfileapprovalFiles.ts";
import { scholarshipFileApprovalAttachmentViewModelSchema } from "../scholarshipFileApprovalAttachmentViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ScholarshipfileapprovalFiles202Schema = z.array(
  z.lazy(() => scholarshipFileApprovalAttachmentViewModelSchema),
) as unknown as ToZod<PostApiV1ScholarshipfileapprovalFiles202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ScholarshipfileapprovalFiles400Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshipfileapprovalFiles400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ScholarshipfileapprovalFiles401Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshipfileapprovalFiles401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ScholarshipfileapprovalFiles404Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshipfileapprovalFiles404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ScholarshipfileapprovalFiles500Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshipfileapprovalFiles500>;

export const postApiV1ScholarshipfileapprovalFilesMutationRequestSchema =
  z.object({
    ScholarshipTypeFileId: z.optional(z.number().int()),
    CourseFinancialPersonId: z.optional(z.number().int()),
    Files: z.optional(z.array(z.instanceof(File))),
  }) as unknown as ToZod<PostApiV1ScholarshipfileapprovalFilesMutationRequest>;

export const postApiV1ScholarshipfileapprovalFilesMutationResponseSchema =
  z.lazy(
    () => postApiV1ScholarshipfileapprovalFiles202Schema,
  ) as unknown as ToZod<PostApiV1ScholarshipfileapprovalFilesMutationResponse>;
